import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

interface IProps {
  name: string;
  underline?: boolean;
  showReason?: boolean;
}

const ConsentSignatureBlock: React.FC<IProps> = ({
  name,
  underline = true,
  showReason = false,
}) => {
  const { t } = useTranslation();
  const subLabel = showReason ? t('labels.reason') : t('labels.signature');
  return (
    <div className={s.grid}>
      <div className={classNames({ [s.underline]: underline })}>{name}:</div>
      <div className={s.underline}>{subLabel}:</div>
      <div className={s.underline}>{t('labels.date')}:</div>
    </div>
  );
};

export default ConsentSignatureBlock;
